import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CampaignGroupFilterBody = _resolveComponent("CampaignGroupFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "campaign_groups",
    ref: "campaignGroupsFilterItem",
    icon: "LayersIcon",
    title: $options.getCampaignGroupTitle,
    selectedTitle: $options.getCampaignGroupSelectedTitle,
    selectedCount: $props.campaign_groups?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_CampaignGroupFilterBody, {
      title: "Campaign group",
      selected: $props.campaign_groups?.filterState?.selected,
      isModified: $props.campaign_groups.isModified,
      pendingChanges: $props.campaign_groups.pendingChanges,
      isSearching: $props.campaign_groups.isSearching,
      keyword: $props.campaign_groups.keyword,
      list: $props.campaign_groups.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.campaign_groups.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: $options.onApply,
      onSearch: $options.handleCampaignGroupsSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.campaignGroupsFilterItem?.closeDropdown
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}